import { registryComponent } from '@boost-sd/components-registry/registry';
import Button from '@components/Button';
import { Icon } from '@components/Icon';
import useTranslation from '@hooks/useTranslation';
import { createClsNameMap, mapModifiers } from '@utils';
import type { ReactNode } from 'react';

const clsNameMap = createClsNameMap({
  elements: {
    customEl: createClsNameMap({
      modifiers: ['disabled'],
    }),
  },
  modifiers: ['outside', 'inside'],
})('next-button');

const DefaultArrowSliderIcon = `
<svg class="boost-sd__next-button-icon" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.764024 5.51189L5.00002 1.28789L9.23602 5.51189" stroke="#212121" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

export type SliderNextButtonProps = {
  customEl?: ReactNode;
  disabled?: boolean;
  position?: 'inside' | 'outside';
  onChange?: () => void;
  style?: React.CSSProperties;
};

const SliderNextButton = ({
  disabled,
  position = 'inside',
  customEl,
  onChange,
  style,
}: SliderNextButtonProps) => {
  const { t } = useTranslation();

  return (
    <div style={style} className={mapModifiers(clsNameMap, [position])}>
      {customEl ? (
        <div
          className={mapModifiers(clsNameMap.customEl, { disabled: disabled })}
          onClick={onChange}
        >
          {customEl}
        </div>
      ) : (
        <Button
          aria-label={t('sliderProduct.nextButton')}
          onClick={onChange}
          disabled={disabled}
          modifiers={['circle']}
        >
          <Icon innerSvg={DefaultArrowSliderIcon} style={{ margin: 0 }} />
        </Button>
      )}
    </div>
  );
};

export default registryComponent('SliderNextButton', SliderNextButton);
